import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
    {
        q: "What is USDT to INR exchange?",
        a: "USDT to INR exchange means converting your Tether (USDT) stablecoin into Indian Rupees at the current exchange rate, with the INR value paid out to you through the DtOrbit exchange process.",
    },
    {
        q: "How can I convert USDT to INR?",
        a: "You can convert USDT to INR on DtOrbit: start an exchange, enter your USDT amount and payout details, send USDT through the supported network, and receive INR once the transaction is processed.",
    },
    {
        q: "What is the current USDT to INR rate?",
        a: "The current USDT to INR rate is shown live on this page — the rate card is fetched directly from DtOrbit and updates automatically. You can also see it on dtorbit.com when you start your exchange.",
    },
    {
        q: "How does DtOrbit USDT to INR exchange work?",
        a: "You visit DtOrbit, enter your exchange details, send USDT through the supported network, and once the transaction is checked and processed, you receive INR according to the exchange flow.",
    },
    {
        q: "Can I sell USDT for INR?",
        a: "Yes. DtOrbit is built for selling USDT for INR — you send your USDT and receive the equivalent INR through your provided payout details, based on the live exchange rate.",
    },
    {
        q: "How do I start a USDT to INR exchange?",
        a: "Click any “Start Exchange” button on this page and you will be taken to the official DtOrbit website, where you can enter your details and begin your exchange.",
    },
    {
        q: "Is the USDT to INR rate live?",
        a: "Yes. The rate displayed on this page is fetched from DtOrbit's live source and refreshes automatically, so you always see the current rate before starting.",
    },
    {
        q: "How are USDT to INR transactions processed?",
        a: "After you send USDT on the supported network, the transaction is verified and processed by DtOrbit. INR is then paid out according to the exchange process. Completion time depends on network confirmation and verification.",
    },
];

export default function Faq() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-16 md:py-24 scroll-mt-20 border-t border-[#E4EAF6]"
        >
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <div className="text-center">
                        <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                            FAQs
                        </span>
                        <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold tracking-tight text-[#0F1B3D]">
                            Frequently Asked Questions About USDT to INR Exchange
                        </h2>
                    </div>
                </Reveal>

                <div className="mt-10 md:mt-12 flex flex-col gap-3.5">
                    {FAQS.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={item.q} delay={i * 60}>
                                <div
                                    data-testid={`faq-item-${i + 1}`}
                                    className={`glass rounded-2xl overflow-hidden transition-colors duration-300 ${
                                        isOpen ? "border-[#1E56FF]/35" : ""
                                    }`}
                                >
                                    <h3>
                                        <button
                                            type="button"
                                            data-testid={`faq-question-${i + 1}`}
                                            aria-expanded={isOpen}
                                            onClick={() => setOpen(isOpen ? -1 : i)}
                                            className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4 sm:py-5"
                                        >
                                            <span className="font-display text-sm sm:text-base font-bold text-[#0F1B3D]">
                                                {item.q}
                                            </span>
                                            <ChevronDown
                                                className={`w-5 h-5 flex-none text-[#1E56FF] transition-transform duration-300 ${
                                                    isOpen ? "rotate-180" : ""
                                                }`}
                                            />
                                        </button>
                                    </h3>
                                    <div
                                        className={`grid transition-all duration-300 ease-out ${
                                            isOpen
                                                ? "grid-rows-[1fr] opacity-100"
                                                : "grid-rows-[0fr] opacity-0"
                                        }`}
                                    >
                                        <div className="overflow-hidden">
                                            <p
                                                data-testid={`faq-answer-${i + 1}`}
                                                className="px-5 sm:px-6 pb-5 text-sm text-[#5B6B8C] leading-relaxed"
                                            >
                                                {item.a}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
